import { render, staticRenderFns } from "./DashboardControlFilters.vue?vue&type=template&id=689ce984&scoped=true"
import script from "./DashboardControlFilters.vue?vue&type=script&lang=js"
export * from "./DashboardControlFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689ce984",
  null
  
)

export default component.exports